import { spacer, colors, fontSize, fonts } from 'settings/style';
import styled from 'styled-components';

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${spacer.lg} 0;
`;

/** Ant Design Pagination: square controls + blue100 accent (shared by all PaginatingItems). */
export const PaginationWrap = styled.div`
  .ant-pagination-item,
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    border-radius: 0;
    color: ${colors.grey900} !important;
  }

  .ant-pagination-item-active {
    background: ${colors.grey100};
    border: 0px;
    border-radius: 5px;

    a {
      color: ${colors.grey900};
    }
  }

  .ant-pagination-item-active:hover {
    a {
      color: ${colors.grey900};
    }
  }

  .ant-pagination-item-link {
    color: ${colors.grey900};
    border-color: ${colors.grey900};

    .anticon {
      color: ${colors.grey900};
    }
  }

  .ant-pagination-prev:not(.ant-pagination-disabled):hover .ant-pagination-item-link,
  .ant-pagination-next:not(.ant-pagination-disabled):hover .ant-pagination-item-link {
    border-color: ${colors.grey900};
    color: ${colors.grey900};
  }

  .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
  .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
    color: ${colors.grey900};
  }
`;

export const StyledWrapper = styled.div``;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacer.md};
  flex-wrap: wrap;
  margin-bottom: ${spacer.xl};
`;

export const StyledTitle = styled.h3`
  color: ${colors.font};
  font-size: ${fontSize.lg};
  font-family: ${fonts.tertiary};
`;
